var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-editor"},[_c('textarea',{ref:"textarea",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }